import { Wrapper, Inner } from "./style";

type SpacerType = "rule" | "short" | "vertical" | "dots" | "gap";

type SpacerConfig = {
  color?: string;
  type?: SpacerType;
  length?: number;
  thickness?: number;
  customClass?: string;
};

type SpacerPluginProps = {
  componentConfig: {
    $id?: string;
    config?: SpacerConfig | string;
  };
  height?: number;
};

function parsePluginConfig(raw: unknown): SpacerConfig {
  if (raw == null) return {};
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw) as SpacerConfig;
    } catch {
      return {};
    }
  }
  return raw as SpacerConfig;
}

export const SpacerComponent = ({ componentConfig, height }: SpacerPluginProps) => {
  const { $id } = componentConfig ?? {};
  const config = parsePluginConfig(componentConfig?.config ?? {});
  const {
    color = "rgba(0,0,0,1)",
    type = "gap",
    length = 50,
    thickness = 1,
    customClass = "",
  } = config;

  return (
    <Wrapper className={customClass} data-id={$id} aria-hidden="true" $height={height}>
      <Inner $type={type} $color={color} $length={length} $thickness={thickness} />
    </Wrapper>
  );
};
